<template>
  <div>
    <AlertaPlano
      text="PLANO GRATUITO"
      callbackText="ASSINAR"
      :callback="() => $router.push({ path: '/assinatura/planos' })"
      :plan="true"
      :backButton="true"
      :isGame="false"
    />

    <div style="height: 56vh">
      <div class="card-promo">
        <div class="w-100 row my-2 d-flex justify-content-center">
          <div
            :class="`${
              detalhes_edicao
                ? 'col-md-6 justify-content-center'
                : 'col-md-12 justify-content-center'
            } d-flex`"
          >
            <span class="length" v-if="items.length > 0">
              {{ items.length }}
              {{ detalhes_edicao ? "PASSATEMPOS" : "EDIÇÕES" }}</span
            >

            <div
              style="height: 48vh"
              v-else
              class="row d-flex justify-content-center align-items-center"
            >
              <span class="oferta">
                NÃO EXISTEM
                {{ detalhes_edicao ? "PASSATEMPOS" : "EDIÇÕES" }}
                DISPONÍVEIS</span
              >
              <div class="card p-3 w-50 text-center">
                FAZER LOGIN PARA TER ACESSO!
                <button
                  @click="$router.push({ path: '/login' })"
                  class="btn-login"
                >
                  FAZER LOGIN
                </button>
              </div>
            </div>
          </div>
          <div
            class="col-md-6 d-flex align-items-center card-compra"
            v-if="!detalhes.usuario_possui_edicao"
          >
            <div
              @click="comprarEdicao()"
              v-if="detalhes_edicao"
              class="card w-75 h-75 d-flex justify-content-center align-items-center"
            >
              <span class="info-product"
                >COMPRAR {{ items.length }} {{ detalhes.subtitulo }} R$
                9,90</span
              >
              <div :class="`btn-play`">
                <i class="fa fa-play"></i>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        v-if="items.length > 0"
        style="position: relative; padding: 0px 40px !important"
      >
        <carousel
          :dots="false"
          :center="false"
          :nav="false"
          :responsive="{
            0: { items: 2, nav: false },
            800: { items: 3, nav: false },
            1300: { items: 4, nav: false },
          }"
          :loop="false"
        >
          <template slot="prev"
            ><span class="btn-prev big-icon"
              ><i class="fa fa-caret-left"></i></span
          ></template>

          <template slot="next"
            ><span class="btn-next big-icon"
              ><i class="fa fa-caret-right"></i></span
          ></template>

          <template v-if="detalhes_edicao">
            <CardGenerico
              v-for="(item, index) in items"
              :key="index"
              :nome="item.titulo"
              :subtitulo="item.texto"
              :descricao="item.data_tratada"
              :id="item.id"
              @toggle-like="toggleLike"
              :foto="item.edicoes.foto"
              :link="`/jogo/${item.id}`"
              :likes="item.curtidas_count ? item.curtidas_count : 0"
              :curtido="item.usuario_curtiu"
              :comentarios="item.comentarios_count ? item.comentarios_count : 0"
            />
          </template>
          <template v-else>
            <CardGenerico
              v-for="(item, index) in items"
              :key="index"
              :nome="item.nome"
              :subtitulo="item.subtitulo"
              :descricao="item.descricao"
              :id="item.id"
              :foto="item.foto"
              :link="`/edicoes/${item.id}/`"
            />
          </template>
        </carousel>
      </div>
    </div>

    <AlertaPlano text="VEJA AS NOVIDADES!" />

    <div>
      <SliderBottom />
    </div>
  </div>
</template>

<script>
import AlertaPlano from "../components/AlertaPlano";
import carousel from "vue-owl-carousel";
import CardGenerico from "../components/CardGenerico";
import SliderBottom from "../components/SliderBottom";

export default {
  components: {
    AlertaPlano,
    carousel,
    CardGenerico,
    SliderBottom,
  },
  data: () => ({
    items: [],
    slider_edicoes: [],
    items_slider: [],
    detalhes_edicao: false,
    detalhes: {},
    logado: false,
  }),
  name: "Home",
  mounted: async function () {
    this.$store.commit("jogo", false);
    if (localStorage.getItem("t")) {
      this.logado = true;
    }
    if (this.$route.params.id == undefined) {
      this.$store.commit("loading", true);
      await this.$axios
        .all([this.$axios.get(`jogo/edicoes`)])
        .then(
          this.$axios.spread(async (edicoesRes) => {
            this.items = edicoesRes.data;

            await this.$store.commit("loading", false);
          })
        )
        .catch(() => {
          this.$store.commit("loading", false);
          this.$store.commit("setStateModal", {
            visible: true,
            title: "Erro de servidor",
            type: "error",
            message:
              "O servidor pode estar temporariamente indisponível, tente mais tarde.",
          });
          this.$router.push({ path: "/" });
        });
    } else {
      this.detalhes_edicao = true;
      this.$store.commit("loading", true);
      await this.$axios
        .all([this.$axios.get(`jogo/edicoes/${this.$route.params.id}`)])
        .then(
          this.$axios.spread(async (edicoesRes) => {
            this.items = edicoesRes.data.passatempos;
            this.detalhes = edicoesRes.data;

            await this.$store.commit("loading", false);
          })
        )
        .catch(() => {
          this.$store.commit("loading", false);
          this.$store.commit("setStateModal", {
            visible: true,
            title: "Erro de servidor",
            type: "error",
            message:
              "O servidor pode estar temporariamente indisponível, tente mais tarde.",
          });
          this.$router.push({ path: "/" });
        });
    }

    console.log(this.$router);
  },
  methods: {
    toggleLike(obj) {
      const i = this.items.findIndex((item) => item.id == obj.id);
      this.items[i].usuario_curtiu = obj.like;
      if (obj.like) {
        this.items[i].curtidas_count = this.items[i].curtidas_count + 1;
      } else {
        this.items[i].curtidas_count = this.items[i].curtidas_count - 1;
      }
    },
    comprarEdicao() {
      this.$store.commit("addItemInCart", {
        type: "edicao",
        payload: this.detalhes,
      });
      this.$router.push({ path: "/assinatura/pagamento" });
    },
    analyticSubmit: function () {
      try {
        this.$intercom.trackEvent("WEB_tela_edicoes");
      } catch (error) {
        console.log("analyticIntercom edicoes error:", error);
      }
    },
  },
};
</script>
<style scoped>
.card-promo .oferta {
  font-size: 35px;
  letter-spacing: 2px;
  font-weight: bold;
}

.card-promo .length {
  font-size: 30px !important;
  font-weight: bold;
  letter-spacing: 2px;
}

.card-compra {
  font-size: 12px;
  padding: 0px 5px;
}

.btn-play {
  width: 35px;
  height: 35px;
  background-color: black;
  transform: rotate(45deg);
  cursor: pointer;
  transition: ease 1s;
  position: absolute;
  right: -25.5px;
}

.btn-play i {
  color: white;
  position: absolute;
  transform-origin: 0 0;
  top: 50%;
  left: 50%;
  transform: rotate(-45deg) translate(-35%, -50%);
  font-size: 10px;
}

.big-icon {
  font-size: 60px !important;
  top: calc(50% - 40px) !important;
}

.info-product {
  font-family: "Agency FB Regular";
  letter-spacing: 2px;
  text-transform: uppercase;
  cursor: pointer;
}

.btn-next {
  position: absolute;
  top: calc(50% - 15px);
  right: 20px;
  color: black;
  font-size: 30px;
  color: black;
  outline: 0;
  z-index: 9999;
  border: none;
}

.btn-prev {
  position: absolute;
  top: calc(50% - 15px);
  left: 20px;
  color: black;
  font-size: 30px;
  z-index: 99999;
  color: black;
  outline: 0;
  border: none;
}

.btn-login {
  border: none;
  width: 100%;
  position: absolute;
  left: 0;
  height: 40px;
  bottom: -40px;
  background-color: #4e9c5f;
  color: white;
}

.card {
  border-radius: 0px;
  border: none;
}
</style>
